import { useNavigate, useLocation } from "react-router-dom";

const TRANSIENT_PARAMS = ["type"];

const useNavigateWithSearch = () => {
  const navigate = useNavigate();
  const location = useLocation();

  return (path, options) => {
    const params = new URLSearchParams(location.search);
    TRANSIENT_PARAMS.forEach((delNam) => {
      params.delete(delNam);
    });
    const search = params.toString();
    navigate(`${path}${search ? `?${search}` : ""}`, options);
  };
};

export default useNavigateWithSearch;
